import React, {useMemo} from 'react';
import {
  useRecommendContext,
  HEADER_PLAN_LABELS,
  useRecommendPlanTypes,
  getMainPlanTypesFactory,
} from '../CreateRecommendHelpers';
import {recommendFieldsType} from '../recommendFields';
import AutoField, {Option} from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import {useAccountContext} from '../../../../contexts/AccountContext';
import {loadMainPlanType, useLoadMainPlanType} from '../../hooks/createRecommendHooks';
import {useRecommendPlanOptionsField} from './useRecommendPlanOptionsField';

interface RecommendPlanOptionsProps {
  isSubmitting: boolean;
}

function RecommendPlanOptions(props: RecommendPlanOptionsProps) {
  const {isSubmitting} = props;
  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();
  const {recommendDetails} = useRecommendContext();
  const {account} = useAccountContext();

  const {mainPlanTypes} = useRecommendPlanTypes(values);
  const getMainPlanTypes = getMainPlanTypesFactory({
    values,
    mainPlanTypes,
  });
  const planTypes = getMainPlanTypes();

  useLoadMainPlanType();
  // advicePlan is now computed via useAdvicePlan hook, not stored in state

  const selectedPlan = useMemo(() => {
    return planTypes.find((p) => p.value === values.mainPlanType);
  }, [planTypes, values.mainPlanType]);

  const selectedLabel = useMemo(() => {
    const label = values.planAction
      ? HEADER_PLAN_LABELS[values.planAction]?.first
      : 'Loading';
    // eslint-disable-next-line no-nested-ternary
    const planName = !selectedPlan
      ? undefined
      : selectedPlan.capitalise
      ? selectedPlan.label
      : selectedPlan.label.toLowerCase();
    const selectedLabelTemp = planName ? `${label} ${planName}` : `${label} plan`;
    return selectedLabelTemp;
  }, [selectedPlan, values.planAction]);

  const field = useRecommendPlanOptionsField({
    planTypes,
    selectedLabel,
    isSubmitting,
    values,
    account,
  });

  return <AutoField field={field} />;
}

export default RecommendPlanOptions;
